import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/Main';
// import Refund from '@/views/Refund';
import Privacy from '@/views/Privacy';
import PrivacyV2 from '@/views/PrivacyV2';
import PrivacyV3 from '@/views/PrivacyV3';
import PrivacyV5 from '@/views/PrivacyV5';
import PrivacyV6 from '@/views/PrivacyV6';
import PrivacyV7 from '@/views/PrivacyV7';
import PrivacyV8 from '@/views/PrivacyV8';
import PrivacyV9 from '@/views/PrivacyV9';
import Terms from '@/views/Terms';
import TermsV2 from '@/views/TermsV2';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Main,
      props: route => ({ section: route.query.section })
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/privacyV2',
      name: 'privacyV2',
      component: PrivacyV2
    },
    {
      path: '/privacyV3',
      name: 'privacyV3',
      component: PrivacyV3
    },
    {
      path: '/privacyV4',
      name: 'privacyV4',
      component: PrivacyV3
    },
    {
      path: '/privacyV5',
      name: 'privacyV5',
      component: PrivacyV5
    },
    {
      path: '/privacyV6',
      name: 'privacyV6',
      component: PrivacyV6
    },
    {
      path: '/privacyV7',
      name: 'privacyV7',
      component: PrivacyV7
    },
    {
      path: '/privacyV8',
      name: 'privacyV8',
      component: PrivacyV8
    },
    {
      path: '/privacyV9',
      name: 'privacyV9',
      component: PrivacyV9
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/termsV2',
      name: 'termsV2',
      component: TermsV2
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.name !== 'home') return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js